/* Maison Brogi — Retailers search + country filter (port of original `Lq`). */
(function () {
  function init(root) {
    if (root.__brogiRetailers) return;
    root.__brogiRetailers = true;
    var input = root.querySelector('[data-retailer-search]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('button[data-country]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-retailer]'));
    var count = root.querySelector('[data-retailer-count]');
    var empty = root.querySelector('[data-retailer-empty]');
    var grid = root.querySelector('[data-retailer-grid]');
    var country = '';

    function apply() {
      var q = (input && input.value || '').toLowerCase();
      var n = 0;
      cards.forEach(function (card) {
        var has = function (k) { return (card.getAttribute('data-search-' + k) || '').indexOf(q) !== -1; };
        var match = (!q || has('name') || has('city') || has('country')) &&
          (!country || card.getAttribute('data-country') === country);
        if (match && card.hidden) {
          // re-play the entry animation for cards that come back (like the original mount animation)
          card.classList.remove('is-revealed');
          card.style.setProperty('--reveal-delay', (n * 0.05) + 's');
          requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-revealed'); }); });
        }
        card.hidden = !match;
        if (match) n++;
      });
      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', (p.getAttribute('data-country') || '') === country ? 'true' : 'false');
      });
      if (count) count.textContent = n + ' ' + (n === 1 ? root.getAttribute('data-label-one') : root.getAttribute('data-label-other'));
      if (empty) empty.hidden = n !== 0;
      if (grid) grid.hidden = n === 0;
    }

    if (input) input.addEventListener('input', apply);
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var c = p.getAttribute('data-country') || '';
        country = c && country === c ? '' : c;
        apply();
      });
    });
  }
  function boot() { document.querySelectorAll('[data-retailers]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
